import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import faqTopQuestionsEN from '../../../data/faq/en/topQuestions';
import faqTopQuestionsFR from '../../../data/faq/fr/topQuestions';
import { FR } from '../../LanguageProvider/constants';
import FaqDiv from './FaqDiv';
import FaqH1 from './FaqH1';
// Custom components
import FaqH2 from './FaqH2';
import FaqText from './FaqText';
// Messages translation
import messages from './messages';
import TopQuestion from './TopQuestion';

const FaqTextIntro = styled(FaqText)`
  ${tw`whitespace-pre-line`};
`;

const MainPage = ({ locale }) => (
  <FaqDiv>
    <FaqH1>
      <FormattedMessage {...messages.faqTitle} />
    </FaqH1>
    <FaqTextIntro>
      <FormattedMessage {...messages.faqDescription} />
    </FaqTextIntro>
    <FaqH2>
      <FormattedMessage {...messages.topQuestions} />
    </FaqH2>
    <TopQuestion
      topQuestions={locale === FR ? faqTopQuestionsFR : faqTopQuestionsEN}
    />
  </FaqDiv>
);

MainPage.propTypes = {
  locale: PropTypes.string,
};

export default MainPage;
